export default __webpack_public_path__ + "7f67ac97e68a29320494fc693a41be6f.png";